import {
  HUMAN_INPUT_DATA_TYPE,
  UI_COMPONENT_LABELS,
  type HumanInputComponentType,
  type HumanInputDataType,
} from "./constants";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface UIComponentSelectorProps {
  dataType: HumanInputDataType | undefined;
  uiComponent: HumanInputComponentType | undefined;
  onUiComponentChange: (component: HumanInputComponentType) => void;
  disabled?: boolean;
}

const UIComponentSelector = ({
  dataType,
  uiComponent,
  onUiComponentChange,
  disabled = false,
}: UIComponentSelectorProps) => {
  const uiComponentOptions = dataType
    ? HUMAN_INPUT_DATA_TYPE[dataType]?.component_options || []
    : [];

  return (
    <Select
      value={uiComponent || undefined}
      onValueChange={value => onUiComponentChange(value as HumanInputComponentType)}
      disabled={disabled}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select a UI component..." />
      </SelectTrigger>
      <SelectContent>
        {uiComponentOptions.map(option => (
          <SelectItem key={option} value={option}>
            {UI_COMPONENT_LABELS[option]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default UIComponentSelector;
